import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sso-pseudo-login',
  template: ``,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PseudoLoginComponent {}
